import { Component, OnInit, Input } from '@angular/core';

import { ClientNewsletter } from 'src/app/shared/api-models/content';
import { PromoBarService } from './promo-bar.service';

@Component({
  selector: 'mp-promo-bar',
  templateUrl: './promo-bar.component.html',
  styleUrls: ['./promo-bar.component.scss']
})
export class PromoBarComponent implements OnInit {

  @Input() newsletter: ClientNewsletter

  constructor(
    public promoBarService: PromoBarService
  ) { }

  ngOnInit(): void {
  }

}
